import React, { Fragment } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import './index.css';
import * as icons from 'common/svg/icons';

export const IconList = props => {
  const { className, list, theme } = props;

  const getIcon = icon => {
    const CustomTag = icons[icon];
    return CustomTag ? <CustomTag className={'iconlist__icon'} /> : null;
  };

  const renderIcons = list.map((item, idx) => (
    <li
      key={idx}
      className={classnames(
        'iconlist__item',
        item.color ? `iconlist__item--${item.color}` : null
      )}
    >
      {item.action && (
        <a
          href={item.href}
          target="blank"
          onClick={item.action}
          className={'iconlist__link'}
        >
          {getIcon(item.icon)}
          {item.label}
        </a>
      )}
      {!item.action && (
        <Fragment>
          {getIcon(item.icon)}
          {item.label}
        </Fragment>
      )}
    </li>
  ));

  const listCSS = classnames(
    'iconlist',
    className,
    theme && theme.map(css => `iconlist--${css}`).join(' ')
  );

  return <ul className={listCSS}>{renderIcons}</ul>;
};

IconList.propTypes = {
  list: PropTypes.array.isRequired,
  className: PropTypes.string,
  theme: PropTypes.array,
};

export default IconList;



// WEBPACK FOOTER //
// ./src/common/components/IconList/index.js